import ComponentBase from '../base/component-base';

/**
 * Header Component
 * Handles fixed header behavior on scroll for home page
 */
class Header extends ComponentBase {
  private scrollThreshold: number = 0;
  private isHome: boolean = false;
  private onScrollBinding: (() => void) | undefined;

  constructor(element: HTMLElement) {
    super(element);

    // Check if this is a home page header
    this.isHome = this.element.classList.contains('is-home');

    if (this.isHome) {
      this.init();
    }
  }

  protected init(): void {
    if (!this.isHome) {
      return;
    }

    this.onScrollBinding = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.onScrollBinding as EventListener, { passive: true });

    // Check initial scroll position
    this.handleScroll();
  }

  private handleScroll(): void {
    const scrollY = window.scrollY || window.pageYOffset;

    if (scrollY > this.scrollThreshold) {
      // Add fixed class when scrolled
      if (!this.element.classList.contains('is-fixed')) {
        this.element.classList.add('is-fixed');
      }
    } else {
      // Remove fixed class when at top
      if (this.element.classList.contains('is-fixed')) {
        this.element.classList.remove('is-fixed');
      }
    }
  }

  protected onDestroy(): void {
    super.onDestroy();

    if (this.onScrollBinding) {
      window.removeEventListener('scroll', this.onScrollBinding as EventListener);
      this.onScrollBinding = undefined;
    }
  }
}

export default Header;
